/*! @pentacode/ui v0.1.0 */
import { FormElement as e } from "./elements/formElement.js";
import "./icon-DW8BBY5W.js";
import { t } from "./styledElement-DUAqv8gi.js";
import { t as n } from "./css-build-DcREbovZ.js";
import { t as r } from "./decorateMetadata-BXz2gmG4.js";
import { t as i } from "./decorate-C_HUHFGG.js";
import { LitElement as a, html as o } from "lit";
import { customElement as s, property as c } from "lit/decorators.js";
// src/elements/checkbox/checkbox.css?inline
var l = "@property --_checkbox-color{syntax:\"<color>|<custom-ident>\";inherits:true;initial-value:#0000}:host{--checkbox-color-unchecked:var(--color-neutral);--checkbox-color-checked:var(--color-positive);vertical-align:middle;color:var(--_checkbox-color);align-self:center;display:inline-block}:host([checked]){--_checkbox-color:var(--checkbox-color-checked)}:host(:not([checked])){--_checkbox-color:var(--checkbox-color-unchecked)}[part=box]{border:max(1px, .0625em) solid var(--_checkbox-color);border-radius:var(--radius-relative);outline-color:var(--_checkbox-color);transition:all .15s ease-in-out;transition-property:var(--_checkbox-color);outline-width:max(2px,.125em);justify-content:center;align-items:center;padding:.25em;display:flex;overflow:hidden}[part=checkmark]{width:1em;height:1em;color:var(--_checkbox-color);opacity:0;transform-origin:50%;line-height:1;transition:transform .15s ease-in-out,opacity .15s ease-in-out;display:block;transform:scale(0)rotate(45deg)}:host([checked]) [part=checkmark]{opacity:1;transform:scale(1)}", u = (e) => [...e].flatMap((e) => e instanceof CSSPropertyRule ? [e.cssText] : "cssRules" in e ? u(e.cssRules) : []), d = n(l, (e) => {
	if (typeof document > "u" || typeof CSSPropertyRule > "u") return () => {};
	let t = new CSSStyleSheet(), n = !1;
	return () => {
		let r = u(e.cssRules);
		t.replaceSync(r.join("\n")), !n && r.length > 0 && (n = !0, document.adoptedStyleSheets = [...document.adoptedStyleSheets, t]);
	};
}), f = class extends t(e(a)) {
	constructor(...e) {
		super(...e), this.styles = d, this.checked = !1, this.defaultChecked = !1;
	}
	get formValue() {
		return this.checked ? this.value || "on" : null;
	}
	formResetCallback() {
		this.checked = this.defaultChecked;
	}
	_toggleState() {
		this.checked = !this.checked, this.dispatchEvent(new CustomEvent("change", {
			bubbles: !0,
			composed: !0,
			detail: { checked: this.checked }
		}));
	}
	_handleClick() {
		this._toggleState();
	}
	_handleKeyDown(e) {
		e.key === " " && (e.preventDefault(), this._toggleState());
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("click", this._handleClick), this.addEventListener("keydown", this._handleKeyDown), this.internals.setFormValue(this.formValue);
	}
	disconnectedCallback() {
		this.removeEventListener("click", this._handleClick), this.removeEventListener("keydown", this._handleKeyDown), super.disconnectedCallback();
	}
	updated(e) {
		e.has("checked") && (this.internals.setFormValue(this.formValue), this.checked ? this.internals.states.add("checked") : this.internals.states.delete("checked")), super.updated(e);
	}
	render() {
		return o`<div role="checkbox" part="box" aria-checked=${this.checked} tabindex="0">
            <ptc-ui-icon part="checkmark" name="icon.status.success"></ptc-ui-icon>
        </div>`;
	}
};
i([c({
	type: Boolean,
	reflect: !0
}), r("design:type", Object)], f.prototype, "checked", void 0), i([c({ type: Boolean }), r("design:type", Object)], f.prototype, "defaultChecked", void 0), f = i([s("ptc-ui-checkbox")], f);
var p = f;
export { p as n, f as t };

//# sourceMappingURL=checkbox-B7K20jTx.js.map